// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";

// kendo

// css
import styles from './userDetail_mobile.module.css';
import "./userDetail_mobile.css";

// services
import { getFile } from '../../../service/mngt/elderService';

function PlacePhotoMobile({conn}) {

  const locationState = useLocation().state;

  const [placePhotoNum, setPlacePhotoNum] = useState(1);
  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
    imgFilePlacePhoto1: "",
    imgFilePlacePhoto2: "",
  });

  const changePlacePhoto = (e) => {
    if(e.target.id === "placePhoto1") {
      setPlacePhotoNum(1);
    } else if(e.target.id === "placePhoto2") {
      setPlacePhotoNum(2);
    }
  }

  const userPhoto = () => {
    getFile(conn, locationState.dataState.fileIdPlacePhoto1)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFilePlacePhoto1 = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
    getFile(conn, locationState.dataState.fileIdPlacePhoto2)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFilePlacePhoto2 = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
  }

  useEffect(() => {
    userPhoto();
  },[])

  return (
    <>
      <div className="pageContent_m">
        <div className="userInfoDetail">
          {placePhotoNum === 1 ?
              <div className={styles.placePhotoBox}>
                {locationState.dataState.fileIdPlacePhoto1 ? <img className={styles.placePhoto} src={imgFile.imgFilePlacePhoto1} alt="사진" /> : <img className={styles.placePhoto} src="/images/mobile/noPlacePhoto2.png" alt="사진" />}
              </div>
              : placePhotoNum === 2 ?
              <div className={styles.placePhotoBox}>
                {locationState.dataState.fileIdPlacePhoto2 ? <img className={styles.placePhoto} src={imgFile.imgFilePlacePhoto2} alt="사진" /> : <img className={styles.placePhoto} src="/images/mobile/noPlacePhoto2.png" alt="사진" />}
              </div>
              : null
            }
          <button className={styles.changePhotoButton} id="placePhoto1" onClick={changePlacePhoto}>사진 1</button>
          <button className={styles.changePhotoButton} style={{marginLeft: "10px"}} id="placePhoto2" onClick={changePlacePhoto}>사진 2</button>
        </div>
      </div>
    </>
  );
}

export default PlacePhotoMobile;
